
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projekt Gemini',
	'appExit': 'Zur Begrüßungsseite',


	'widgetsListLabel': 'Widgetliste. Wählen Sie ein Widget aus und drücken Sie die Eingabetaste, um es hinzuzufügen.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Aktuell',
	'dirty': 'Nicht aktuell',
	'conflict': 'Konflikt beim Speichern der Ansicht',
	'error': 'Problem beim Speichern der Ansicht',
	'failure': 'Kontaktieren des Servers nicht möglich',
	'saveFailed': 'Speichern der Ansicht nicht möglich',

	'wa_insync': 'Gespeichert',
	'wa_conflict': 'Konflikt beim Speichern der Ansicht',
	'wa_error': 'Speichern der Ansicht nicht möglich',
	'wa_failure': 'Kontaktieren des Servers nicht möglich',

	// Menu Labels
	'changeDisplay': 'Anzeige ändern',
	'changeToColumnChart': 'Zu Säulendiagramm wechseln',
	'changeToBubbleChart': 'Zu Blasendiagramm wechseln',
	'toggleMoveHandles': 'Schiebeelemente ein-/ausblenden',
	'undo': 'Rückgängig machen',
	'redo': 'Wiederholen',
	'mode': 'Modus ändern',

	'untitled': 'Nicht benannt',
	'remove': 'Entfernen',
	'editTitle': 'Titel bearbeiten',
	'edit': 'Bearbeiten',
	'done': 'Fertig',

	// Data tray
	'dataTrayHandleOpenLabel': 'Datenablage öffnen',
	'dataTrayHandleCloseLabel': 'Datenablage schließen',

	// Dialogs
	'dlg_loading': 'Ladeoperation wird ausgeführt...',
	'dlg_ok': 'OK',
	'dlg_create': 'Erstellen',
	'dlg_cancel': 'Abbrechen',
	'dlg_close': 'Schließen',
	'dlg_update': 'Aktualisieren',
	'dlg_renameBoardTitle': 'Dieses Objekt umbenennen',
	'dlg_renameDatasetTitle': 'Dieses Dataset umbenennen',
	'dlg_renameSceneTitle': 'Diese Szene umbenennen',
	'dlg_NameLabel': 'Name:',
	'dlg_NewNameLabel': 'Neuer Name:',
	'dlg_DefaultNameWithDataSet': '%{name} - Ansicht',
	'dlg_ShareTitle': 'Inhalt teilen',
	'dlg_UnshareTitle': 'Inhalt nicht teilen',
	'dlg_ShareUser': 'Benutzer-ID:',
	'dlg_NewColumnLabel': 'Neuer Berechnungsname',

	'dlg_new': 'Neu...',
	'dlg_open': 'Öffnen...',
	'dlg_makeACopy': 'Kopie erstellen',
	'dlg_rename': 'Umbenennen...',
	'dlg_moreToCome': 'Weitere Aktionen...',

	'dlg_use': 'Verwenden',

	'dlg_RelinkDatasetTitle': 'Dataset \'%{datasetName}\' ersetzen durch...',

	'open_error': 'Beim Öffnen der Ansicht ist ein Problem aufgetreten.',

	// Delete Board
	'del_dialogTitle': 'Löschen bestätigen',
	'del_itemMsg': 'Soll \'%{name}\' tatsächlich gelöscht werden?',
	'del_itemsMsg': 'Sollen %{count} Elemente tatsächlich gelöscht werden?',
	'del_deleteErr': 'Löschen von \'%{name}\' nicht möglich',

	// List Sorting
	'dlg_ascending': 'aufsteigend',
	'dlg_descending': 'absteigend',
	'dlg_custom': 'benutzerdefiniert',
	'dlg_none': 'Ohne',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Suchen',

	'searchHint': 'Alle Daten durchsuchen',
	'clearSearchResult': 'Suchergebnisse löschen',
	// Shapes and shapes categories
	// Basic shapes
	'shapesBasicShapesCat': 'Grundformen',
	'shapesCircle': 'Kreis',
	'shapesHexagon': 'Sechseck',
	'shapesLine': 'Linie',
	'shapesOctagon': 'Achteck',
	'shapesPentagon': 'Fünfeck',
	'shapesSquare': 'Quadrat',
	'shapesTriangle': 'Dreieck',
	'shapesDiamond': 'Raute',
	'shapesTitle': 'Eigenschaften für Formen',


	// Advanced shapes
	'shapesAdvancedShapesCat': 'Erweitert',
	'shapesSquareRounded': 'Abgerundetes Quadrat',
	'shapesStar': 'Stern',
	'shapesChevron': 'Winkel',
	'shapesBadge_ribbon': 'Kokarde',
	'shapesBadge': 'Kokarde',
	'shapesHeart': 'Herz',
	'shapesExclamation': 'Ausrufezeichen',
	'shapesTrendingup': 'Aufwärtstrend',
	'shapesTrendingdown': 'Abwärtstrend',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Personen',
	'shapesFemale': 'Weiblich',
	'shapesHappyface': 'Fröhliches Gesicht',
	'shapesMale': 'Männlich',
	'shapesMan': 'Mann',
	'shapesNeutralface': 'Neutrales Gesicht',
	'shapesSadface': 'Trauriges Gesicht',
	'shapesShakehands': 'Handschlag',
	'shapesThumbsdown': 'Daumen nach unten',
	'shapesThumbsup': 'Daumen nach oben',
	'shapesWoman': 'Frau',

	// Weather and places
	'shapesPlacesWeatherCat': 'Orte und Wetter',
	'shapesCity': 'Stadt',
	'shapesCloud': 'Wolke',
	'shapesEducation': 'Ausbildung',
	'shapesGovernment': 'Regierung',
	'shapesHalfcloud': 'Halbe Wolke',
	'shapesHouse': 'Haus',
	'shapesMoon': 'Mond',
	'shapesRain': 'Regen',
	'shapesSunny': 'Sonne',

	//Vehicles
	'shapesVehiclesCat': 'Fahrzeuge',
	'shapesAirplane': 'Flugzeug',
	'shapesCar': 'Auto',
	'shapesShip': 'Schiff',
	'shapesShoppingcart': 'Einkaufswagen',
	'shapesTrain': 'Eisenbahn',
	'shapesTruck': 'LKW',

	//Objects
	'shapesObjectsCat': 'Objekte',
	'shapesBook': 'Buch',
	'shapesBriefcase': 'Aktenkoffer',
	'shapesCalendar': 'Kalender',
	'shapesCheck': 'Scheck',
	'shapesClock': 'Uhr',
	'shapesDesktop': 'Desktop',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Nahrungsmittel',
	'shapesGear': 'Zahnrad',
	'shapesHealth': 'Gesundheit',

	'shapesIdea': 'Idee',
	'shapesMobile': 'Mobilgerät',
	'shapesMoney_bill': 'Geldschein',
	'shapesMoney_coin': 'Geldmünze',
	'shapesPiggybank': 'Sparschwein',
	'shapesStackofpaper': 'Papierstapel',
	'shapesStickynote1': 'Kurznotiz 1',
	'shapesStickynote2': 'Kurznotiz 2',
	'shapesTarget': 'Ziel',
	'shapesTool': 'Werkzeug',

	'shapesUmbrella': 'Schirm',

	'shapesBrain': 'Gehirn',
	'shapesSkull': 'Schädel',
	'shapesEye': 'Auge',

	// Arrows shapes
	'shapesArrowsCat': 'Pfeile',
	'shapesRightArrow': 'Rechtspfeil',
	'shapesLeftArrow': 'Linkspfeil',
	'shapesDoubleArrow': 'Doppelpfeil',
	'shapesCurvedArrow': 'Gebogener Pfeil',

	// Callouts shapes
	'shapesCalloutsCat': 'Beschriftungen',
	'shapesRectCallout': 'Beschriftung',

	// Images
	'imageWidgetTitle': 'Bildwidget',
	'imageTextLabel': 'URL einfügen und die Eingabetaste zum Speichern drücken',
	'imgUrl': 'Bild-URL',
	'imgPasteLink': 'URL einfügen und die Eingabetaste zum Speichern drücken',
	'imgResizeToFit': 'An Bildgröße anpassen',
	'imgHeight': 'Höhe:',
	'imgWidth': 'Breite:',
	'imgTransparency': 'Transparenz:',
	'imgMissingUrl': 'Bild-URL fehlt',
	'imgUrlValidationError': 'Bild-URL ist nicht gültig',
	'imgUrlInvalidDomainError': 'Die Bild-URL verweist auf eine Domäne, die nicht vom Administrator genehmigt wurde. Vom Administrator genehmigte Domänen: "%{domains}"',


	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Wiedergabe',
	'dataPlayerValueListLabel': 'Data Player-Werte',
	// Text Widget
	'textWidgetTitle': 'Textwidget',
	'textStyle': 'Stile',
	'textStyleDescription': 'Vorformatierte Textstile',
	'textTitleStyle': 'Titel',
	'textTitleSmallStyle': 'Titel - klein',
	'textSubtitleStyle': 'Untertitel',
	'textBodyStyle': 'Hauptteil',
	'textBodySmallStyle': 'Hauptteil - klein',
	'textCaptionStyle': 'Titelzeile',
	'textQuoteStyle': 'Zitat',
	'textQuoteSmallStyle': 'Zitat - klein',
	'textResponsiveStyle': 'Größe automatisch anpassen',
	'textAutoFontSize': 'Automatisch',
	'textFontFamilySubClassHairline': 'Haarlinie',
	'textFontFamilySubClassThin': 'Dünn',
	'textFontFamilySubClassThinItalic': 'Dünn kursiv',
	'textFontFamilySubClassExtraLight': 'Sehr hell',
	'textFontFamilySubClassExtraLightItalic': 'Sehr hell kursiv',
	'textFontFamilySubClassLight': 'Hell',
	'textFontFamilySubClassLightItalic': 'Hell kursiv',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Normal kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Mittel',
	'textFontFamilySubClassMediumItalic': 'Mittel kursiv',
	'textFontFamilySubClassHeavy': 'Stark',
	'textFontFamilySubClassHeavyItalic': 'Stark kursiv',
	'textFontFamilySubClassDemiBold': 'Halbfettdruck',
	'textFontFamilySubClassDemiBoldItalic': 'Halbfettdruck kursiv',
	'textFontFamilySubClassBold': 'Fettdruck',
	'textFontFamilySubClassBoldItalic': 'Fettdruck kursiv',
	'textFontFamilySubClassExtraBold': 'Extrafettdruck',
	'textFontFamilySubClassExtraBoldItalic': 'Extrafettdruck kursiv',
	'textFontFamilySubClassBlack': 'Schwarz',
	'textFontFamilySubClassBlackItalic': 'Schwarz kursiv',
	'textFontFamilySubClassStencil': 'Schablone',
	'responsiveCoachmarkTitle': 'Schriftgröße automatisch anpassen',
	'responsiveCoachmarkContents': 'Beim Ändern der Größe für diesen Texttyp wird die Schriftgröße automatisch angepasst. Die Schriftgröße kann in den Texteigenschaften festgelegt werden.',

	'propText': 'Textdetails',
	'propTextReturn': 'Texteigenschaften',

	'textFontSize': 'Schriftgröße',
	'textFontFamily': 'Schriftartengruppe',
	'textFontWeight': 'Schriftstärke',

	// Widget Properties
	'propImageLink': 'Bildlink',
	'propMissingURL': 'URL eingeben',
	'propImgTop': 'Bildeigenschaften',
	'propGeneralReturn': 'Allgemeine Eigenschaften',
	'propStyle': 'Allgemein',
	'propStyleReturn': 'Allgemein',
	'propFillColor': 'Füllfarbe',
	'propTextColor': 'Textfarbe',
	'propBorderColor': 'Umrandungsfarbe',
	'propMaintainAxisScales': 'Achsenskala beibehalten',
	'propShowItemLabel': 'Elementbeschriftung anzeigen',
	'propHideLegend': 'Legende ausblenden',
	'propColorPalette': 'Palette',
	'propLegendPosition': 'Position der Legende',
	'propHideAxisTitleLabels': 'Achsentitel ausblenden',
	'propLineColor': 'Linienfarbe',
	'propBubbleColor': 'Blasenfarbe',
	'propInterpolation': 'Geglättete Linien',
	'propElementColor': 'Farbe des Visualisierungselements',
	'propSymbolShape': 'Symbolform',
	'propHeatScalePalette': 'Farbreihenfolge',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Dunklere Farben stellen niedrigere Werte dar.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Dunklere Farben stellen höhere Werte dar.',
	'propImageDetails': 'Bilddetails',
	'propWebDetails': 'Webseitendetails',
	'propMediaDetails': 'Mediendetails',
	'propPasteLink': 'URL eingeben und die Eingabetaste drücken',

	//Layout Properties
	'propPositionLabel': 'Position',
	'propPositionXAxis': 'X',
	'propPositionYAxis': 'Y',
	'propResizeLabel': 'Größe',
	'propResizeWidth': 'Breite',
	'propResizeHeight': 'Höhe',
	'propRotateLabel': 'Drehen',
	'propRotateAngle': 'Winkel',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Menge der Symbole',
	'propScaleDescription': 'Menge der Symbole auswählen',
	'propScaleFew': 'Niedrig',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Hoch',

	'mediaAriaLabel': 'URL-Eingabe',
	'ariaGroupLabel': 'Dropdown-Listenkategorie: %{cateoryLabel} Element: %{itemLabel}. Zum Einblenden Abwärtstaste drücken. Mit der Aufwärts- bzw. Abwärtstaste navigieren oder zum Ausblenden Abbruchtaste (Esc) drücken.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Letzte Aktualisierung: Vor %{timeInterval}',
	'widgetTimer': 'Widget-Zeitgeber',

	// Theme colors
	'transparent': 'Keine Farbe',
	'white': 'Weiß',
	'lightGrey': 'Hellgrau',
	'grey': 'Grau',
	'darkGrey': 'Dunkelgrau',
	'black': 'Schwarz',
	'lightBlue': 'Hellblau',
	'blue': 'Blau',
	'darkBlue': 'Dunkelblau',
	'yellow': 'Gelb',
	'orange': 'Orange',
	'lime': 'Limone',
	'green': 'Grün',
	'peach': 'Pfirsich',
	'red': 'Rot',
	'violet': 'Violett',
	'aqua': 'Wasserblau',
	'purple': 'Lila',
	'plum': 'Pflaumenblau',

	//Theme Palette Label
	'paletteLabel': 'IBM - Palette %{number}',
	'heatPaletteLabel': 'IBM - Palette für Heat-Map %{number}',
	'conditionalPaletteLabel': 'IBM - Bedingte Palette %{number}',
	'userPaletteColor_lightTheme': 'IBM - Helle Palette',
	'userPaletteColor_defaultTheme': 'IBM - Standardpalette',
	'userPaletteColor_darkTheme': 'IBM - Dunkle Palette',

	// Dashboard
	'propDashboardBackgroundColor': 'Hintergrundfarbe',
	'dataCache': 'Datencache',
	'dataCache_on': 'Aktiviert',
	'dataCache_off': 'Kein Cache',
	'dataCache_auto': 'Automatisch',
	'propLayoutPositioning': 'Layoutpositionierung',
	'propLayoutRelative': 'Relativ',
	'propLayoutAbsolute': 'Absolut',
	'propLayoutPositioningCoachmarkTitle': 'Layoutstil auswählen',
	'propLayoutPositioningCoachmarkContent': 'In einem relativen Layout werden Größe und Position der Widgets an die Anzeige angepasst. Widgets in einem absoluten Layout werden exakt mit der von Ihnen festgelegten Größe und Position in der Ansicht angezeigt, unabhängig von der Anzeigengröße.',
	'gridText': 'Raster anzeigen',
	'snapText': 'Am Raster ausrichten',
	'snapObjectsText': 'An Objekten ausrichten',
	'fitPageText': 'An Seite anpassen',
	'gridLabel': 'Raster',
	'heightUnit': 'h',
	'widthUnit': 'b',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Seitengröße',
	'propPageSizePresetAriaLabel': 'Voreinstellung für Seitengröße',
	'propPageSizePreset': 'Voreingestellt',
	'propPageSizePresetCustom': 'Benutzerdefiniert',
	'propPageSizePreset16x9': 'Anzeige 16:9',
	'propPageSizePreset4x3': 'Anzeige 4:3',
	'propPageSizePresetInfographic': 'Infografik',
	'propPageSizeWidth': 'Breite',
	'propPageSizeHeight': 'Höhe',
	'propPageSizeWidthAriaLabel': 'Seitengröße - Breite',
	'propPageSizeHeightAriaLabel': 'Seitengröße - Höhe',
	'propPageSizeAdjustedMessage': 'Der Wert für die Seitengröße wurde erhöht, da die Eingabe unter dem Minimalwert lag oder nicht passend für das Dashboard war.',
	'propTabShow': 'Registerkarten anzeigen',
	'propShowTabsInPreview': 'Registerkarten in der Vorschau anzeigen',
	'multilingualDashboardsLabel': 'Sprachen',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Standard',
	'multilingualDashboardsAddLinkText': 'Weitere Sprache hinzufügen',
	'multilingualDashboardsSelect': 'Auswählen',
	'multilingualDashboardsButtonLabel': 'Hinzufügen',
	'multilingualDashboardTranslationMode': 'Der Übersetzungsmodus ist nun aktiviert (%{currentLanguage}).',
	'multilingualDashboardTranslationDone': 'Fertig',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} verbleibende Übersetzungen',
	'multilingualDashboardRemainingString': '1 verbleibende Übersetzung',
	'multilingualDashboardsSetDefault': 'Standardsprache festlegen',
	'multilingualDashboardIconMore': 'Weitere Aktionen für die Sprache %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Übersetzbarer Bereich',
	'multilingualDeleteTitle': 'Sprache löschen',
	'multilingualDeleteLanguageWarning': 'Soll die Sprache \'%{language}\' tatsächlich gelöscht werden?',
	'multilingualSelectLanguage': 'Sprache auswählen',
	'confirmLayoutStyleUpgradeTitle': 'Für alle Registerkarten anwenden',
	'confirmLayoutStyleUpgrade': 'Diesen Layoutstil für alle Registerkarten im Dashboard anwenden?',

	//Tabs
	'tabDeleteDialogYesButton': 'Ja',
	'tabDeleteDialogNoButton': 'Nein',
	'tabDeleteDialogTitle': 'Diese Registerkarte löschen?',
	'tabDeleteDialogMessage': 'Der gesamte Inhalt dieser Registerkarte wird ebenfalls gelöscht.',

	// Vis widget
	'propVisTypeReturn': 'Visualisierungstypen',
	'propVisDetails': 'Details',

	// Alignment picker
	'propAlignPickTop': 'Oben ausrichten',
	'propAlignPickRight': 'Rechts ausrichten',
	'propAlignPickBottom': 'Unten ausrichten',
	'propAlignPickLeft': 'Links ausrichten',
	'propAlignPickCenter': 'Zentriert ausrichten',
	'propAlignPicker': 'Ausrichtung',

	// Toolbar picker
	'propToolbarPickBold': 'Fettdruck',
	'propToolbarPickUnderline': 'Unterstrichen',
	'propToolbarPickItalic': 'Kursiv',
	'propToolbarPickJustifyLeft': 'Links ausrichten',
	'propToolbarPickJustifyCenter': 'Zentriert ausrichten',
	'propToolbarPickJustifyRight': 'Rechts ausrichten',
	'propToolbarPickJustify': 'Ausrichten',

	'propList': 'Liste',
	'propOrderedList': 'Geordnete Liste',
	'propUnorderedList': 'Ungeordnete Liste',

	// Symbol shapes
	'propCircle': 'Kreis',
	'propTriangle': 'Dreieck',
	'propSquare': 'Quadrat',
	'propRect': 'Rechteck',
	'propStar': 'Stern',
	'propCross': 'Kreuz',
	'propPlus': 'Pluszeichen',
	'propPoly': 'Polygon',


	// True and false selection
	'propTrue': 'Wahr',
	'propFalse': 'Falsch',

	// Position selection
	'propLeft': 'Links',
	'propRight': 'Rechts',
	'propTop': 'Oben',
	'propBottom': 'Unten',

	// Interpolation options
	'propSmooth': 'Geglättet',
	'propStraight': 'Gerade',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Liste', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Nach links', // screen reader
	'srWidgetMoveUp': 'Nach oben', // screen reader
	'srWidgetMoveRight': 'Nach rechts', // screen reader
	'srWidgetMoveDown': 'Nach unten', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Proportional vergrößern', // screen reader
	'srWidgetResizeSmaller': 'Proportional verkleinern', // screen reader
	'srWidgetResizeBiggerV': 'Vertikal vergrößern', // screen reader
	'srWidgetResizeSmallerV': 'Vertikal verkleinern', // screen reader
	'srWidgetResizeBiggerH': 'Horizontal vergrößern', // screen reader
	'srWidgetResizeSmallerH': 'Horizontal verkleinern', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Im Uhrzeigersinn drehen', // screen reader
	'srWidgetRotateCCW': 'Gegen den Uhrzeigersinn drehen', // screen reader

	// Recommended types
	'visChange': 'Visualisierung ändern',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisierung',
	'chartLabel': 'Diagramm %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Mit F12 im Widget navigieren.',
	'f10KeyDescription': 'Mit F10 die im Fokus befindliche Ansicht des Widgets starten',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} mit Wert %{value}',

	'shapeColorLabel': 'Farbe für Formen',
	'showLegendLabel': 'Legende anzeigen',

	//Webpage
	'webpageWidgetTitle': 'Webseitenwidget',
	'webpagePasteLink': 'URL einfügen und die Eingabetaste zum Speichern drücken',
	'propWebpageLink': 'Webseiten-URL',
	'propWebpageTitle': 'Webseitentitel',
	'propWebpageTitleDescription': 'Titel der Webseite',
	'propWebpageTop': 'Webseiteneigenschaften',
	'webpageMissingUrl': 'Webseiten-URL fehlt',
	'webpageUrlValidationError': 'Webseiten-URL ist nicht gültig',
	'webpageHttpValidationError': 'Der Zugriff auf die Webseite muss über einen HTTPS-Link erfolgen, damit der Browser sie anzeigen kann.',
	'webpageInvalidDomainError': 'Die Webseiten-URL verweist auf eine Domäne, die nicht vom Administrator genehmigt wurde. Vom Administrator genehmigte Domänen: "%{domains}"',

	//VizState
	'vzErrorLoading': 'Laden der Visualisierung nicht möglich.',
	'vzErrorLoadingMissingData': 'Laden der Visualisierung nicht möglich, Kontextdaten fehlen.',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Medienwidget',
	'mediaPasteLink': 'URL einfügen und die Eingabetaste zum Speichern drücken',
	'videoHeight': 'Höhe:',
	'videoWidth': 'Breite:',
	'propMediaLink': 'Link für Medien',
	'propMediaTitle': 'Titel für Medien',
	'propMediaTitleDescription': 'Titel für Medien',
	'propMediaTop': 'Eigenschaften für Medien',
	'mediaMissingUrl': 'Link-URL für Medien fehlt',
	'mediaUrlValidationError': 'URL für Mediendatei ist nicht gültig',
	'mediaUnknownValidationError': 'Dieser Medientyp wird nicht unterstützt',
	'mediaHttpValidationError': 'Der Zugriff auf die Mediendatei muss über einen HTTPS-Link erfolgen, damit der Browser sie anzeigen kann.',
	'mediaInvalidDomainError': 'Die Mediendatei-URL verweist auf eine Domäne, die nicht vom Administrator genehmigt wurde. Vom Administrator genehmigte Domänen: "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': 'Eigenschaften',

	// Data strip
	'dataSetsLabel': 'Dataset',
	'dataViewsLabel': 'Ansicht',
	'columnQuality': 'Datenqualität',
	'columnProperties': 'Dateneigenschaften',

	'dataQuality': 'Datenqualität',
	'dataQualityRowCount': 'Anzahl der Zeilen',
	'dataQualityDistribution': 'Verteilung',
	'dataRowLabel': 'Daten',

	// Modelling UI
	'typeColumn': 'Typ',
	'modellingColumnType': 'Typ',
	'modellingColumnAggregation': 'Aggregation',
	'modellingColumnUsage': 'Verwendung',
	'modellingColumnSort': 'Sortieren',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Kategorie',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Ladeoperation wird ausgeführt...',

	'modellingProcessing': 'Verarbeitung wird ausgeführt...',
	'modellingImport': 'Importieren',
	'modellingReimport': 'Erneut importieren',
	'modellingDatasourceTitle': 'Datenquelle',
	'modellingImportStartedTitle': 'Import gestartet',
	'modellingImportStartedText': 'Das Importieren der Daten kann einige Zeit in Anspruch nehmen.\n\n(Sie können eine Ansicht erstellen, während die Daten importiert werden.)',
	'importDatasourceTitle': 'Verbindungen',
	'dropHere': 'Zum Erstellen einer neuen Datenquelle hier ablegen...',
	'browseButton': 'Durchsuchen',
	'errorNoData': 'Es sind keine Daten zur Verarbeitung vorhanden.',
	'errorNoFile': 'Es ist keine Datei für den Upload vorhanden.',
	'errorUploadFailed': 'Upload nicht möglich.',
	'uploadSucceessful': 'Upload erfolgreich.',
	'del_datasourceTitle': 'Dataset löschen',
	'del_datasourceMsg': 'Soll \'%{name}\' tatsächlich gelöscht werden?',
	'modellingFileUpdate': 'Aktualisieren',
	'modellingFileUpdateTitle': 'Dataset aktualisieren',
	'modellingFileUpdateDescription': 'Soll \'%{name}\' aktualisiert werden?',
	'modellingFileUpdatingTitle': '\'%{name}\' wird aktualisiert',
	'modellingUpdateStartedTitle': 'Aktualisierungsimport gestartet',
	'modellingUpdateStartedText': 'Das Aktualisieren der Daten kann einige Zeit in Anspruch nehmen.\n\n(Sie können eine Ansicht erstellen, während die Daten aktualisiert werden.)',
	'modellingErrorImportUploadNoFile': 'Es ist keine Datei für den Upload vorhanden.',
	'modellingErrorImportUploadFailed': 'Upload nicht möglich.',
	'modellingErrorImportUploadInvalidType': 'Der Dateityp ist nicht gültig.',
	'modellingErrorImportUploadTableFailed': 'Abrufen von Tabellen nicht möglich.',
	'modellingIntentResultsTitle': 'Vorgeschlagenes Dataset auswählen',
	'modellingColumnViewRelationships': 'Zugehörige Tabellen anzeigen',
	'modellingTableRelatedTables': 'Zu \'%{name}\' gehörende Tabellen',
	'modellingTable': '%{name} - Tabelle',
	'modellingColumnIncludedInDataSet': 'Hinzugefügt',
	'modellingDataSet': 'Dataset',
	'modellingViewInDataSet': 'In Dataset anzeigen',
	'modellingViewRelatedTables': 'Zugehörige anzeigen',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Keine zugehörigen Tabellen gefunden',

	'modellingValidatingDataset': 'Überprüfung wird ausgeführt...',
	'datasetFinishedRefreshing': 'Dataset %{datasetName} wurde aktualisiert.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Joinpfad auflösten:',
	'modellingJoinColumns': 'Joinpfad definieren für Tabelle: %{name}',
	'modellingJoinToTable': 'Join mit Tabelle: %{name}',

	// Data Quality
	'excluded': 'Ausgeschlossen',
	'metricPrefixThousand': 'Tsd',
	'metricPrefixMillion': 'Mio',
	'metricPrefixBillion': 'Mrd',
	'metricPrefixTrillion': 'Bil',
	'metricPrefixQuadrillion': 'Brd',

	//Column Flyout
	'modellingColumnFilter': 'Filtern',
	'modellingColumnSortNone': 'Sortierung aufheben',
	'modellingColumnSortAsc': 'Aufsteigend sortieren',
	'modellingColumnSortDesc': 'Absteigend sortieren',
	'modellingColumnRemove': 'Diese Spalte entfernen',

	// Import File Browser
	'dropboxPageTitle': 'Neue Dropbox-Verbindung',
	'sizeColumn': 'Größe',

	//Modelling Column Property Values
	'dataType_string': 'Zeichenfolge',
	'dataType_date': 'Datum',
	'dataType_integer': 'Ganzzahl',
	'dataType_double': 'Double',
	'dataType_float': 'Gleitkomma',
	'dataType_boolean': 'Boolescher Wert',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Anzahl',
	'defaultAggregation_countdistinct': 'Anzahl eindeutiger Elemente',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Durchschnitt',
	'defaultAggregation_sum': 'Summe',
	'defaultAggregation_auto': 'Autom. (%{aggregationType})',

	'type_fact': 'Fakt',
	'type_attribute': 'Attribut',

	'defaultSort_none': 'Nicht sortieren',
	'defaultSort_asc': 'Aufsteigend sortieren',
	'defaultSort_desc': 'Absteigend sortieren',

	'category_none': 'Ohne',
	'category_location': 'Position',
	'category_monetary': 'Währung',
	'category_time': 'Zeit',

	// Root menu
	'rootMenuTitle': 'Hauptmenü',

	'errorMessageTitle': 'Fehler',
	'errorMessageDetails': 'Details: ',
	'errorMessageTitleAssetAlreadyExists': 'Asset ist bereits vorhanden',

	'defaultTabTitle': 'Registerkarte %{index}',
	'tabAddBtnTitle': 'Neue Registerkarte hinzufügen',

	'unsupportedConditionalFormattingEncountered': 'Bedingte Formatierung wird für einige Spalten nicht mehr angewendet. ',


	// Homepage View
	'nameColumn': 'Name',
	'creatorColumn': 'Erstellt von',
	'creationDateColumn': 'Erstellungsdatum',
	'versionColumn': 'Version',
	'modifiedColumn': 'Letzte Änderung',

	'filterBy': 'Filterelemente',
	'allFilter': 'Alle Elemente',
	'createdByMeFilter': 'Von mir erstellt',
	'sharedWithMeFilter': 'Mit mir geteilt',
	'favoritesFilter': 'Eigene Favoriten',
	'recentsFilter': 'Kürzlich hinzugefügt',
	'sortBy': 'Sortieren nach',

	// Sort Menu
	'sortModified': 'Geändert',
	'sortUpdated': 'Aktualisiert',
	'sortName': 'Name',

	'viewAs': 'Anzeigen als',
	'thumbnailsView': 'Als Piktogramm anzeigen',
	'listView': 'Als Liste anzeigen',
	'createMenu': 'Erstellen',
	'newAppItem': 'Dashboard',
	'newDataSet': 'Dataset',

	'menuSelectionState_a11y': 'Auswahl für "%{item}": "%{selectedItem}"',

	'unableToShareItem': 'Element "%{item}" kann nicht geteilt werden.',
	'toastFetchingContent': 'Weitere Inhalte werden abgerufen...',
	'unableToGetData': 'Abrufen von Inhalten nicht möglich.',
	'unableToFavorite': 'Ändern des Favoritenstatus nicht möglich.',
	'hpErrorMissingRequiredOptions': 'Erforderliche Initialisierungsoptionen fehlen',
	'unableToOpenBoard': 'Öffnen von "%{name}" nicht möglich.',
	'unableToDuplicateBoard': 'Duplizieren von "%{name}" nicht möglich.',
	'unableToCreateBoard': 'Erstellen von "%{name}" nicht möglich.',
	'unableToCreateBoardNameConflict': 'Es ist bereits ein Asset mit demselben Namen vorhanden.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Zeilen',
	'importWarnings': 'Warnungen',
	'lineNumbers': 'Zeilen',
	'excerptFromSource': 'Auszug',
	'reason': 'Ursache',
	'numberOfRowsDropped': 'Zeilen nicht berücksichtigt',
	'oneRowDropped': '1 Zeile wurde nicht berücksichtigt',

	// Type Menu
	'typeMenuLabel': 'Typ',
	'dashboardsLabel': 'Dashboards',
	'datasetsLabel': 'Datasets',
	'storiesLabel': 'Storys',
	'allLabel': 'Alle Typen',

	// Board Page View App Bar
	'datasets': 'Datasets',
	'settings': 'Eigenschaften',
	'add': 'Hinzufügen',
	'widgets': 'Widgets',
	'dashboardProperties': 'Dashboardeigenschaften',
	'pins': 'Sammlung',
	'pinsOld': 'Eigene Pins',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} Pin |||| %{smart_count} Pins',
	'pinSearch': 'Suchen',
	'pinSearchOld': 'Pins suchen',
	'pinListView': 'Listenansicht',
	'pinIconView': 'Symbolansicht',
	'pinRemove': 'Entfernen',
	'pinCreate': 'Erstellen',
	'pinDeleteError': 'Ein oder mehrere Assets können nicht aus der Sammlung gelöscht werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',
	'pinDeleteErrorOld': 'Ein oder mehrere Pins können nicht gelöscht werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',
	'pinRetrieveError': 'Ein oder mehrere Pins können nicht abgerufen werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',
	'NoPinsCollected': 'Keine Visualisierungen mit Pins',
	'pinDeletedToast': 'Pin wurde entfernt',
	'pinAddedToast': 'Pin wurde erfolgreich zu eigenen Pins hinzugefügt',
	'pinningToast': 'Pin wird verarbeitet...',
	'pinDateFilter': 'Datumsfilter',
	'pinDateFilterAll': 'Alle',
	'pinDateFilterToday': 'Heute',
	'pinDateFilterYesterday': 'Gestern',
	'pinDateFilterPastWeek': 'Letzte Woche',
	'pinDateFilterPastMonth': 'Letzten Monat',
	'pinDateFilterEarlier': 'Zu einem früheren Zeitpunkt',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Titel bearbeiten',
	'toolbarActionSort': 'Sortieren',
	'toolbarActionSortAscending': 'Aufsteigend sortieren',
	'toolbarActionSortDescending': 'Absteigend sortieren',
	'toolbarActionSortAuto': 'Autom. (%{sortOrder})',
	'toolbarActionFormat': 'Format',
	'toolbarActionFormatAbbreviation': 'Abkürzen',
	'toolbarActionFormatNone': 'Automatisch',
	'toolbarActionFilter': 'Filtern',
	'toolbarActionTopBottom': 'Oben oder unten',
	'toolbarActionAddShape': 'Form hinzufügen',
	'toolbarActionRmvShape': 'Form entfernen',
	'toolbarActionToggleShapeDrop': 'Form der Infografik',
	'toolbarActionToggleShapeDropTitle': 'Infografik erstellen',
	'toolbarActionToggleShapeDropText': 'Eine Form in dieses Feld ziehen, um eine Infografik zu erstellen.',
	'toolbarActionAggregationType': 'Zusammenfassen',
	'toolbarDeleteActionText': 'Spalte entfernen',
	'toolbarActionFilterLocalKeepSelected': 'Beibehalten',
	'toolbarActionFilterLocalExcludeSelected': 'Ausschließen',
	'toolbarActionFilterAllKeepSelected': 'Filtern',
	'toolbarActionSimpleCalculation': 'Einfache Berechnung',
	'toolbarActionDrillBack': 'Zurück',
	'toolbarActionDrillUp': 'Drillup',
	'toolbarActionDrillDown': 'Drilldown',
	'toolbarActionNavigate': 'Navigation',
	'toolbarActionCreateFilterGroup': 'Neue Verbindung erstellen',
	'toolbarActionDisconnectFilterGroup': 'Alle Links trennen',
	'toolbarActionLinkFilterGroup': 'Zu einer vorhandenen Verbindung hinzufügen',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Hinzufügen',
	'sidebarMultiselect': 'Mehrfachauswahl aktivieren/inaktivieren',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} ausgewählt',

	'multiselectWithTotalMsg': '%{count} von %{total}',
	'sidebarGoBack': 'Zurück',

	//DataSet pane
	'errorLoadingDataSets': 'Dieses Dataset kann nicht geladen werden.',
	'errorLoadingDataSetMetaData': 'Dieses Dataset kann nicht geladen werden.',
	'dataSetPaneLastUpdated': 'Letzte Aktualisierung: %{date}',
	'dataSetPaneDateUnknown': 'Unbekannt',
	'sourcePaneLabel': 'Ausgewählte Quellen',
	'addSourceLabel': 'Quelle hinzufügen',
	'find_label': 'Suchen',
	'navigationPathsLabel': 'Navigationspfade',

	//widgetlist
	'errorLoadingWidgetList': 'Die Objekte können nicht geladen werden.',
	'errorLoadingThemeFile': 'Die Motivdefinition kann nicht geladen werden.',
	'errorLoadingLayoutFile': 'Die Ansicht kann nicht geladen werden.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Die verfügbaren Visualisierungsdefinitionen können nicht geladen werden.',

	'dwErrorLoadingVisualizationNotFound': 'Das Objekt kann nicht geladen werden, da eine Visualisierungsdefinition fehlt.',
	'dwErrorLoadingVisualizationListNotFound': 'Die Visualisierung kann nicht geladen werden.',
	'dwErrorRunningQuery': 'Die Daten aus dem Dataset %{datasetName} können nicht abgerufen werden.',
	'dwErrorGeoData': 'Es gibt Probleme bei der Anzeige der geografischen Daten in einer Karte. Wählen Sie einen anderen Visualisierungstyp aus. ',
	'dwPromptSignonCancelWarning': 'Die Daten für diese Visualisierung sind nicht verfügbar. Geben Sie die korrekten Berechtigungsnachweise an.',
	'dwErrorMissingDataset': 'Die Visualisierung kann nicht geladen werden, da das zugehörige Dataset \'%{datasetName}\' nicht verfügbar ist.',
	'dwErrorRenderingVisualization': 'Diese Visualisierung kann nicht geladen werden.',
	'dwErrorVisualizationTooSmall': 'Die Visualisierung ist für die Anzeige der darin enthaltenen Daten zu klein. Vergrößern Sie die Visualisierung oder verringern Sie die Menge der darin enthaltenen Daten.',
	'aria_label_datatable': 'Datentabelle',
	'aria_key_navi_datatable_desc': 'Mit den Pfeiltasten zu den einzelnen Zellen navigieren. Mit der Tastenkombination Strg+Pos1 zur ersten Zeile navigieren, mit der Tastenkombination Strg+Ende zur letzten Zeile.',
	'geomapUnrecognizedLocations': 'Nicht erkannte Positionen:',
	'geomapAmbiguousLocations': 'Nicht eindeutige Regionen:',

	// custom widget
	'customWidget': 'Benutzerdefiniertes Widget',
	'noCustomWidgets': 'Keine benutzerdefinierten Widgets',

	// Action names
	'toggleContextBar': 'Kontextleiste ein-/ausblenden',
	'delete': 'Löschen',
	'share': 'Teilen',
	'unshare': 'Nicht teilen',
	'rename': 'Umbenennen',
	'close': 'Schließen',
	'duplicate': 'Duplizieren',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Wiederholen',

	'changeTemplate': 'Vorlage ändern',

	// Aggregation Types
	'sum': 'Summe',
	'count': 'Anzahl',
	'countdistinct': 'Anzahl eindeutiger Elemente',
	'avg': 'Durchschnitt',
	'min': 'Minimum',
	'max': 'Maximum',
	'custom': 'Benutzerdefiniert',
	'calculated': 'Berechnet',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% Änderung',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualisierungskriterien...',
	'QuickAddResultsHeader': 'Datenvisualisierungen',
	'NoQuickAddResults': 'Für Ihre Anfrage sind keine Übereinstimmungen vorhanden. Neues Dataset erstellen?',
	'NoQuickAddResultsRetry': 'Es können keine Übereinstimmungen gefunden werden. Wiederholen Sie den Vorgang mit anderen Begriffen.',
	'templateWidgetTitle': 'Vorlage',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(leer)',

	'nullValueContent': '(kein Wert)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Textfilter - %{columnName}',

	'textFilterSelectTab': 'Auswählen',

	'textFilterConditionTab': 'Bedingung auswählen',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Keine Elemente verfügbar.',

	'textFilterEquals': 'Ist gleich',
	'textFilterContains': 'Enthält',
	'textFilterBeginsWith': 'Beginnt mit',
	'textFilterEndsWith': 'Endet mit',
	'textFilterDoesNotEqual': 'Ist nicht gleich',
	'textFilterDoesNotContain': 'Enthält nicht',
	'textFilterDoesNotBeginWith': 'Beginnt nicht mit',
	'textFilterDoesNotEndWith': 'Endet nicht mit',
	'textFilterSampleText': 'Beispiel: A',

	'textFilterAndButton': 'Und',
	'textFilterOrButton': 'Oder',

	'dateFilterMessage': 'Datumsbereich auswählen',
	'dateRangeControlRegionLabel': 'Datumsbereichsfilter - %{columnName}',
	'dateFilterRangeOption': 'Bereichsoption',
	'dateFilterDateLabel': 'Datum',
	'dateFilterBlank': '(leer)',
	'dateFilterBefore': 'Vor',
	'dateFilterAfter': 'Nach',
	'dateFilterBetween': 'Zwischen',
	'dateFilterSampleText': 'JJJJ-MM-TT',
	'dateTitle': 'Datum',
	'dateIncludeBlankLabel': 'Leeres Datum einfügen',

	'timeTitle': 'Zeit',
	'timeFilterMessage': 'Zeitbereich auswählen',
	'dateTimeFilterMessage': 'Datums- und Zeitbereich auswählen',

	'topbottomNumberOfResultsLabel': 'Anzahl der Ergebnisse',
	'topbottomPercentLabel': 'Prozent',
	'topbottomNumberOfResultsLimit': 'Zwischen %{lower} und %{higher}',
	'topbottomSelectOption': 'Option für obere oder untere Werte',
	'topbottomOptionLabel': 'Anzeigen',
	'searchByLabel': 'Nach',
	'searchNoMatches': 'Keine Übereinstimmungen gefunden',
	'topbottomRankColumnLabel': 'Rangfolgespalte zur Tabelle hinzufügen',
	'topbottomNone': 'Ohne',
	'topCount': 'Obere Werte',
	'topPercent': 'Obere %',
	'bottomCount': 'Untere Werte',
	'bottomPercent': 'Untere %',
	'topbottomSearchColumn': 'Spalte suche',
	'searchColumnAriaLabel': 'Spalte suchen. Geben Sie den Namen der Spalte ein, nach der gesucht werden soll, und verwenden Sie den Abwärtspfeil, um die Spalte in einer Liste zu suchen.',
	'rankColumnLabel': 'Rangfolge (%{columnLabel})',
	'topbottomClearLabel': 'Aufheben',

	'rangeFilterControlRegionLabel': 'Bereichsfilter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Schiebereglersteuerelement, mit dem Rechts- bzw. Linkspfeiltasten können Sie die Ziehpunkte des Schiebereglers bewegen.',
	'sliderHandleLabel': 'Ziehpunkt für Schieberegler',
	'a11ySliderHandleLabel': 'Ziehpunkt für Schieberegler %{sliderValue}',
	'sliderInputLabel': 'Wert',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Einige Datasetelemente in dieser Visualisierung sind nicht verfügbar.',
	'datasetItemUnavailable': 'Dieses Dataset ist nicht verfügbar',

	//Authoring topBottom
	'topOperator': 'Obere',
	'bottomOperator': 'Untere',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} nach %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Nur dieses Objekt',
	'deleteTopBottom': 'Anzahl oberer oder unterer Werte löschen',
	'editTopBottom': 'Anzahl oberer oder unterer Werte bearbeiten',
	'deleteDrillState': 'Aktuellen Drillstatus löschen',
	'ariaDeleteDrillStateLabel': 'Zum Bearbeiten der Anzahl oberer oder unterer Werte Eingabetaste drücken.',
	'drillUpStateTitle': 'Drillup',
	'drillDownStateTitle': 'Drilldown',
	'ariaEditTopBottomLabel': 'Zum Bearbeiten der Anzahl oberer oder unterer Werte Eingabetaste drücken.',
	'ariaDeleteTopBottomLabel': 'Zum Löschen der Anzahl oberer oder unterer Werte Löschtaste drücken.',

	// Authoring filtering
	'dimFilterIn': 'Einbezogen: %{in}',
	'dimFilterNotIn': 'Ausgeschlossen: %{out}',
	'measureFilterBetween': 'Zwischen %{lowerBound} und %{upperBound}',
	'measureFilterNotBetween': 'Nicht zwischen %{lowerBound} und %{upperBound}',
	'gtFilter': 'Nach %{lowerBound}',
	'ltFilter': 'Vor %{upperBound}',
	'notGtFilter': 'Nicht nach %{lowerBound}',
	'notLtFilter': 'Nicht vor %{upperBound}',
	'localFilterTitle': 'Nur dieses Objekt',
	'globalFilterTitle': 'Alle Objekte',
	'deleteFilter': 'Filter löschen',
	'editFilter': 'Filter bearbeiten',
	'ariaEditFilterLabel': 'Zum Bearbeiten des Filters die Eingabetaste drücken.',
	'ariaDeleteFilterLabel': 'Zum Löschen des Filters die Löschtaste drücken.',

	// Prompts
	'ariaEditPrompt': 'Zum Ändern des Eingabeaufforderungswerts die Eingabetaste drücken',

	'moreDataIndicator': 'Die Daten wurden nach %{threshold} Elementen abgeschnitten. Wenden Sie einen Filter an, um weniger Elemente anzuzeigen.',

	// data point filtering
	'dataPointFilterTitle': 'Datenpunkte',
	'dataPointFilterIncludeSummary': '%{valueCount} Datenpunkte einbezogen',
	'dataPointFilterExcludeSummary': '%{valueCount} Datenpunkte ausgeschlossen',

	// DB2 connection page
	'db2Database': 'DB2-Datenbank (%{jdbcConnection})',
	'db2Title': 'Verbindung mit IBM DB2',

	// Database
	'databaseConnectionMessage': 'Datenbankverbindungsdetails angeben:',
	'connectionString': 'Datenbankverbindungszeichenfolge',
	'databaseCredentials': 'Berechtigungsnachweise: ',
	'databaseUserName': 'Benutzername',
	'databasePassword': 'Kennwort',
	'databaseConnect': 'Verbindung herstellen',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Suchbegriff eingeben:',
	'twitterKeyword': 'Schlüsselwort',
	'twitterSearch': 'Suchen',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Ansicht kann nicht erstellt werden: %{error}\nFehlgeschlagene Operation: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Widgetfilter',
	'missingColumn': 'Nicht vorhanden: %{columnLabel}',
	'missingFiltering': 'Filter für die folgenden Spalten-IDs nicht vorhanden:',
	'heatByLabel': 'Heat-Map nach',
	'evColumns': 'Spalten',
	'evLocalFilters': 'Lokale Filter',
	'evExpand': 'Einblenden',
	'evFilterTooltip': 'Filtern',
	'evAdd': 'Spalte hinzufügen',

	// Navigation View
	'navigationBack': 'Zurück',

	// Pinning
	'contentPinFail': 'Der Inhalt kann nicht erfasst werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',
	'contentPinFailOld': 'Der Inhalt kann nicht fixiert werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',

	// Layouts
	'dropZoneLabel': 'Für maximale Größe hier ablegen',

	//Share
	'shareDefaultPageTitle': 'Seite %{index}',

	'nextPage': 'Nächste Seite',
	'previousPage': 'Vorherige Seite',

	'assetAssembly': 'Ansicht',

	'toolbar_save': 'Speichern',
	'brgr_saveAs': 'Speichern unter',
	'brgr_refresh': 'Aktualisieren',

	// Save
	'saving': 'Speichern wird ausgeführt...',
	'save_success': 'Die Ansicht wurde gespeichert.',
	'save_failure': 'Tut uns leid. Die Ansicht konnte nicht gespeichert werden. Wiederholen Sie die Aktion zu einem späteren Zeitpunkt.',
	'dashboard_save_success': 'Das Dashboard wurde gespeichert.',

	'geminiLeave': 'Sie verlassen IBM Watson Analytics.',

	'warning': 'Warnung',
	'missingDataSetData': 'Die Daten für dieses Dataset sind nicht verfügbar. Aktualisieren Sie das Dataset oder wenden Sie sich an den Administrator, um Zugriff auf die Quelle zu erhalten.',

	// Calculations
	'error_calculation_in_use': 'Die ausgewählte Berechnung wird verwendet und kann nicht gelöscht werden.',

	'resize': 'Größe ändern',
	'rotate': 'Drehen',
	'moveHandle': 'Widget verschieben',
	'expandHandle': 'Einblenden',
	'panHandle': 'Verschieben',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigieren zu',

	// Slide out titles
	'shapeSlideoutTitle': 'Formen',
	'textSlideoutTitle': 'Text',
	'mediaSlideoutTitle': 'Medien',
	'visualizationSlideoutTitle': 'Visualisierungen',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Angegebene JSON-Daten sind nicht gültig. Das Fehlerprotokoll enthält gegebenenfalls weitere Informationen.',

	// Widget type labels
	'shape_label': 'Form',
	'image_label': 'Bild',
	'data_label': 'Diagramm',
	'media_label': 'Medien',
	'text_label': 'Text',
	'embedMedia_label': 'Medien',
	'youtube_label': 'YouTube-Video',
	'webpage_label': 'Webseite',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Form',
	'noExtraText_shape_numbered': 'Form (%{number})',
	'few_shape': 'Gruppe mit %{count} Formen',
	'many_shape': 'Gruppe mit %{count} Formen',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Bild - %{text}',
	'one_image_numbered': 'Bild - %{text} (%{number})',
	'noExtraText_image': 'Bild',
	'noExtraText_image_numbered': 'Bild (%{number})',
	'few_image': 'Gruppe mit %{count} Bildern',
	'many_image': 'Gruppe mit %{count} Bildern',
	'noExtraText_text': 'Leeres Textfeld',
	'noExtraText_text_numbered': 'Leeres Textfeld (%{number})',
	'few_text': 'Gruppe mit %{count} Textfeldern',
	'many_text': 'Gruppe mit %{count} Textfeldern',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Kreuztabelle mit %{values} nach %{row_level1} und %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Kreuztabelle mit %{values} nach %{row_level1} und %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Kreuztabelle mit %{values} nach %{row_level1}',
	'crosstab_has_mapping_numbered': 'Kreuztabelle mit %{values} nach %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Leere Kreuztabelle',
	'crosstab_no_mapping_numbered': 'Leere Kreuztabelle (%{number})',
	'crosstab_named': 'Kreuztabelle %{name}',
	'crosstab_named_numbered': 'Kreuztabelle %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Tabelle - %{grid_cols}',
	'JQGrid_has_mapping_numbered': 'Tabelle - %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Leere Tabelle',
	'JQGrid_no_mapping_numbered': 'Leere Tabelle (%{number})',
	'JQGrid_named': 'Tabelle %{name}',
	'JQGrid_named_numbered': 'Tabelle %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Hierarchie - %{level1}',
	'hierarchy_has_mapping_numbered': 'Hierarchie %{level1} (%{number})',
	'hierarchy_no_mapping': 'Leere Hierarchie',
	'hierarchy_no_mapping_numbered': 'Leere Hierarchie (%{number})',
	'hierarchy_named': 'Hierarchie %{name}',
	'hierarchy_named_numbered': 'Hierarchie %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Karte - %{categories}',
	'map_has_mapping_numbered': 'Karte - %{categories} (%{number})',
	'map_no_mapping': 'Leere Karte',
	'map_no_mapping_numbered': 'Leere Karte (%{number})',
	'map_named': 'Karte %{name}',
	'map_named_numbered': 'Karte %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Zusammenfassungswert - %{actual}',
	'summary_has_mapping_numbered': 'Zusammenfassungswert %{actual} (%{number})',
	'summary_no_mapping': 'Leerer Zusammenfassungswert',
	'summary_no_mapping_numbered': 'Leerer Zusammenfassungswert (%{number})',
	'summary_named': 'Zusammenfassungswert %{name}',
	'summary_named_numbered': 'Zusammenfassungswert %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'KPI mit %{actual} und %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'KPI mit %{actual} und %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'KPI - %{actual}',
	'kpi_has_mapping_numbered': 'KPI - %{actual} (%{number})',
	'kpi_no_mapping': 'Leerer KPI',
	'kpi_no_mapping_numbered': 'Leerer KPI (%{number})',
	'kpi_named': 'KPI %{name}',
	'kpi_named_numbered': 'KPI %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infografik - %{actual}',
	'infographicSummary_has_mapping_numbered': 'Infografik - %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Leere Infografik',
	'infographicSummary_no_mapping_numbered': 'Leere Infografik (%{number})',
	'infographicSummary_named': 'Infografik %{name}',
	'infographicSummary_named_numbered': 'Infografik %{name} (%{number})',
	'noExtraText_youtube': 'YouTube-Video',
	'noExtraText_youtube_numbered': 'YouTube-Video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'YouTube-Video - %{text}',
	'one_youtube_numbered': 'YouTube-Video - %{text} (%{number})',
	'few_youtube': 'Gruppe mit %{count} YouTube-Videos',
	'many_youtube': 'Gruppe mit %{count} YouTube-Videos',
	'noExtraText_embedMedia': 'Link für Medien',
	'noExtraText_embedMedia_numbered': 'Link für Medien (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Link für Medien - %{text}',
	'one_embedMedia_numbered': 'Link für Medien - %{text} (%{number})',
	'few_embedMedia': 'Gruppe mit %{count} Links für Medien',
	'many_embedMedia': 'Gruppe mit %{count} Links für Medien',
	'noExtraText_media': 'Medien',
	'noExtraText_media_numbered': 'Medien (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Medien - %{text}',
	'one_media_numbered': 'Medien - %{text} (%{number})',
	'few_media': 'Gruppe mit %{count} Medien',
	'many_media': 'Gruppe mit %{count} Medien',
	'noExtraText_webpage': 'Webseite',
	'noExtraText_webpage_numbered': 'Webseite (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Webseite - %{text}',
	'one_webpage_numbered': 'Webseite - %{text} (%{number})',
	'few_webpage': 'Gruppe mit %{count} Webseiten',
	'many_webpage': 'Gruppe mit %{count} Webseiten',
	'one_unknown': 'Objekt',
	'one_unknown_numbered': 'Objekt (%{number})',
	'few_unknown': 'Gruppe mit %{count} Objekten',
	'many_unknown': 'Gruppe mit %{count} Objekten',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Weiter',
	'previous': 'Zurück',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Aktuelle Navigationsgruppe: %{navigation_group_name}',

	//Page Context
	'filterBlank': '(leer)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Laden der Filterwerte nicht möglich',
	'editTimelineHighlight': 'Hervorhebung bearbeiten',

	'filterDockChevronLeft': 'In den Daten blättern',
	'filterDockChevronRight': 'In den Daten blättern',
	'expand': 'Einblenden',
	'collapse': 'Ausblenden',

	//Reset Dashboard
	'dashboardResetTitle': 'Dashboard zurücksetzen',
	'dashboardResetMessage': 'Sollen alle für dieses Dashboard angewendete Änderungen tatsächlich zurückgesetzt werden?',
	'dashboardResetToast': 'Das Dashboard wurde zurückgesetzt.',

	//Generate PDF
	'buildingPDF': 'PDF-Erstellung...',
	'exportPDF': 'In PDF exportieren',
	'pageSize': 'Seitengröße',
	'orientation': 'Ausrichtung',
	'filtersPresentPDF': 'Für die Visualisierung(en) auf der vorhergehenden Seite angewendete(r) Filter:',
	'errorPDF': 'Generieren der PDF nicht möglich. Aktualisieren und den Vorgang wiederholen.',
	'printPDFInfo': 'Dokumentation anzeigen',
	'pdfWidget': 'Widget',
	'includeFilters': 'Filterdetails anzeigen',
	'portrait': 'Hochformat',
	'landscape': 'Querformat',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Für das Dashboard wurde ein Upgrade durchgeführt. Jetzt speichern, um eine optimale Leistung zu erhalten.',

	'ariaFullScreenMessage': 'Escapetaste drücken, um den Gesamtanzeigemodus zu verlassen',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Kompaktes Blasendiagramm mit Hierarchien - %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Kompaktes Blasendiagramm mit Hierarchien - %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Leeres kompaktes Blasendiagramm mit Hierarchien',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Leeres kompaktes Blasendiagramm mit Hierarchien (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Kompaktes Blasendiagramm mit Hierarchien %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Kompaktes Blasendiagramm mit Hierarchien %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Marimekko-Diagramm mit %{categories} und %{values}',
	'LIVE_marimekko_has_mapping_numbered': 'Marimekko-Diagramm mit %{categories} und %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Leeres Marimekko-Diagramm',
	'LIVE_marimekko_no_mapping_numbered': 'Leeres Marimekko-Diagramm (%{number})',
	'LIVE_marimekko_named': 'Marimekko-Diagramm %{name}',
	'LIVE_marimekko_numbered': 'Marimekko-Diagramm %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Sunburst-Diagramm - %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Sunburst-Diagramm - %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Leeres Sunburst-Diagramm',
	'LIVE_sunburst_no_mapping_numbered': 'Leeres Sunburst-Diagramm (%{number})',
	'LIVE_sunburst_named': 'Sunburst-Diagramm %{name}',
	'LIVE_sunburst_named_numbered': 'Sunburst-Diagramm %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Diagramm der Einflussfaktorenanalyse - %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Diagramm der Einflussfaktorenanalyse - %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Leeres Diagramm der Einflussfaktorenanalyse',
	'LIVE_decision_analysis_no_mapping_numbered': 'Leeres Diagramm der Einflussfaktorenanalyse (%{number})',
	'LIVE_decision_analysis_named': 'Diagramm der Einflussfaktorenanalyse %{name}',
	'LIVE_decision_analysis_named_numbered': 'Diagramm der Einflussfaktorenanalyse %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Linien- und Säulendiagramm mit %{categories}, %{columnValue} und %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Linien- und Säulendiagramm mit %{categories}, %{columnValue} und %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Linien- und Säulendiagramm mit %{columnValue} und %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': 'Linien- und Säulendiagramm mit %{categories}, %{columnValue} und %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Leeres Linien- und Säulendiagramm',
	'LIVE_line_column_no_mapping_numbered': 'Leeres Linien- und Säulendiagramm (%{number})',
	'LIVE_line_column_named': 'Linien- und Säulendiagramm %{name}',
	'LIVE_line_column_named_numbered' : 'Linien- und Säulendiagramm %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Blasendiagramm mit %{x}, %{y} und %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Blasendiagramm mit %{x}, %{y} und %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Leeres Blasendiagramm',
	'LIVE_bubble_chart_no_mapping_numbered': 'Leeres Blasendiagramm (%{number})',
	'LIVE_bubble_chart_named': 'Blasendiagramm %{name}',
	'LIVE_bubble_chart_named_numbered': 'Blasendiagramm %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Bullet-Diagramm - %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Bullet-Diagramm - %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Leeres Bullet-Diagramm',
	'LIVE_bullet_no_mapping_numbered': 'Leeres Bullet-Diagramm (%{number})',
	'LIVE_bullet_named': 'Bullet-Diagramm %{name}',
	'LIVE_bullet_named_numbered': 'Bullet-Diagramm %{name} (%{number})'
});
